import request from '../../utils/request';
import { Search } from '@/DTOS/ProviderGroup/Search';

const ProviderGroupService = {
  search: (search: Search) => {
    return request('/providerGroup/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ name: any; isActive: any; }} */ formData: {
    name: any;
    isActive: any;
  }
  ) => {
    return request('/providerGroup/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          isActive: formData.isActive,
        },
      }),
    });
  },
};

export default ProviderGroupService;
